import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Input, SelectAnimalFetchInput, SelectInput } from 'src/components'
import { useStyles } from '../styles'
import { formatDateToInputValue } from 'src/utils'
import { CoverageProcessParams } from 'src/domain/coverage-process'
import { LotDto } from 'src/dto/lot.dto'

interface InseminacaoArtificialFormProps {
  lotList: LotDto[]
}

const InseminacaoArtificialForm: React.FC<InseminacaoArtificialFormProps> = ({ lotList }) => {
  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<CoverageProcessParams>()
  const style = useStyles()

  return (
    <fieldset className='fieldsetInsemination'>
      <SelectAnimalFetchInput
        label='Vaca'
        selectBy='id'
        showBy={['cdn', 'nome']}
        hidden={['MT', 'VD']}
        filteredSex='Fêmea'
        value={watch('idVaca') || ''}
        error={errors?.idVaca?.message}
        placeholder='Selecionar vaca'
        onChange={(item: any) => {
          setValue('idVaca', item.id)
          clearErrors('idVaca')
        }}
      />

      <Input
        type='date'
        max='2999-12-31'
        label='Data do cio'
        id='data_cio'
        error={errors?.dataCio?.message}
        onChange={(value: any) => {
          const date = new Date(value).toISOString()
          setValue('dataCio', date)
          clearErrors('dataCio')
        }}
        value={formatDateToInputValue(watch('dataCio') || '')}
      />

      <SelectAnimalFetchInput
        label='Touro'
        selectBy='id'
        showBy={['cdn', 'nome']}
        // hidden={['MT', 'VD']}
        filteredSex='Macho'
        value={watch('idTouro') || ''}
        error={errors?.idTouro?.message}
        placeholder='Selecionar touro'
        onChange={(item: any) => {
          setValue('idTouro', item.id)
          clearErrors('idTouro')
        }}
      />

      <SelectInput
        label='Lote do Touro'
        selectBy='idLote'
        showBy={['descricao']}
        options={lotList}
        value={watch('idLote') || ''}
        error={errors?.idLote?.message}
        placeholder='Selecionar Lote do Touro'
        onChange={(item: any) => {
          setValue('idLote', item.id)
          clearErrors('idLote')
        }}
      />

      <fieldset>
        <legend className={style.formTitle}>Dados Inseminação</legend>

        <Input
          label='Número de doses'
          id='doses'
          placeholder='Número de doses: ex. 01'
          type='text'
          className='halfWidth'
          error={errors?.dosagem?.message}
          onChange={(value: any) => {
            setValue('dosagem', value)
            clearErrors('dosagem')
          }}
          value={watch('dosagem') || ''}
        />

        <Input
          label='Partida'
          id='partida'
          placeholder='Número de partida: ex. 01'
          type='text'
          className='halfWidth'
          error={errors?.partida?.message}
          onChange={(value: any) => {
            setValue('partida', value)
            clearErrors('partida')
          }}
          value={watch('partida') || ''}
        />

        <Input
          label='Inseminador'
          id='inseminador'
          placeholder='Nome do inseminador'
          type='text'
          className='halfWidth'
          error={errors?.inseminador?.message}
          onChange={(value: any) => {
            setValue('inseminador', value)
            clearErrors('inseminador')
          }}
          value={watch('inseminador') || ''}
        />

        <Input
          label='CDC'
          id='cdc'
          placeholder='CDC'
          type='text'
          className='halfWidth'
          error={errors?.cdc?.message}
          onChange={(value: any) => {
            setValue('cdc', value)
            clearErrors('cdc')
          }}
          value={watch('cdc') || ''}
        />
      </fieldset>
    </fieldset>
  )
}

export default InseminacaoArtificialForm
